import { ChangeBorrowCourseFormComponent } from "../../../components/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCourseFormComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function ChangeBorrowCourseFormContainer() {
  const titleName =
    "แบบแจ้งเปลี่ยนแปลงหลักสูตรการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ChangeBorrowCourseFormComponent />
      <Footer />
    </div>
  );
}
